<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-columns"></i> Customize Columns
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <span><i class="fas fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <p>You can drag and drop to reorder columns or click to exclude it completely.</p>
  <mat-button-toggle-group ngxDroppable [model]="columns" [multiple]="true" [formControl]="columnsCtrl" aria-label="Font Style">
    <mat-button-toggle *ngFor="let item of columns"
                       ngxDraggable
                       [checked]="item.excluded"
                       [disabled]="item.restricted"
                       [moves]="!item.restricted"
                       [model]="item" [value]="item.name">{{item.label}}</mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="reset()" type="button" class="btn btn-warning left-icon text-uppercase">
    <i class="fal fa-sync"></i> Reset
  </button>
  <button (click)="submit()" type="button" class="btn btn-success left-icon text-uppercase">
    <span class="fal fa-save"></span> Save
  </button>
</div>
